import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'is_there_written_documentation_surrounding_the_terms_and_condit'

export const dataPointDefinition = {
  retracedId: 'is_there_written_documentation_surrounding_the_terms_and_condit',
  name: 'Is there written documentation surrounding the terms and conditions of the granting and repayment of advances and loans?',
  description:
    "The intent of this question is to understand if there is WRITTEN documentation for the loan/advance terms and conditions. For both the granting process (the initial loan giving) and the re-payment process (how and when loans are to be paid back.)\r\r\n\r\r\nExamples include: Written documentation on the amount given, frequency of re-payment, the interest rate charged, what happens in case the worker can't pay the money back etc.",
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-17--3',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 8800,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
